export default __webpack_public_path__ + "static/media/femme-carottes.4ea72188.png";